import React from "react";
import { useRouter } from "next/router";
import { Button } from "../../shadcn/components/ui/button";

export const BankerPageNotFound = () => {
  const router = useRouter();
  return (
    <div className="flex flex-col items-center mt-[40px] lg:mt-[160px]">
      <p className="font-openSans font-semibold text-[104px] leading-[142px] text-brand-orange">
        404
      </p>
      <p className="md:mt-6 font-openSans font-bold text-mobile-h3 md:text-[38px] leading-10 md:leading-[51px] text-brand-bgBlack">
        Page not found
      </p>
      <p className="text-center text-mobile-body-sm max-w-[300px] md:max-w-[390px] font-openSans font-normal md:text-web-body-lg leading-[22px] text-brand-textGrey md:mt-7">
        The page you are looking for might have been removed temporarily or
        doesn&apos;t exist
      </p>
      <Button
        onClick={() => router.push("/")}
        className="mt-6 md:mt-11 font-openSans font-semibold text-mobile-body-sm md:text-web-body-lg leading-4 text-white py-2 md:py-3 px-8 md:px-[60px]"
        size={"custom"}
      >
        Go to Dashboard
      </Button>
    </div>
  );
};

export default BankerPageNotFound;
